import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ErrorInfo, isErrorInfo } from '../../../shared/interfaces/error-info.interface';
import { RootState } from '../../../shared/redux/reducers';
import useWindowResizer from '../../../shared/hooks/window-resizer/window-resizer.hook';
import {
  InputText,
  InputTextType
} from '../../../shared/components/core-ui/input-text/input-text.component';
import Select, { ValueType } from 'react-select';
import {
  getAllAreas,
  getAllCity,
  getAllUnitTypeGroups
} from '../../../shared/services/data/lookups.data';
import { AreaUiModel } from '../../../shared/ui-models/area.ui-model';
import { getAllUnitTypes } from '../../../shared/services/data/unit-type.data';
import { UnitTypeUiModelResponse } from '../../../shared/ui-models/unit-type.ui-model';
import Button, {
  ButtonSize,
  ButtonType
} from '../../../shared/components/core-ui/button/button.component';
import { getModuleName } from '../../shared/services/reservation.service';
import { getAllReservations } from '../../shared/services/data.service';
import {
  ReservationListUiModel,
  ReservationUiModel
} from '../../../shared/ui-models/reservation.ui-model';
import { ReservationStatus } from '../../../shared/enums/reservation-status';
import { APP_ROUTES, PUBLIC_PATH, WEBSITE_HOME } from '../../../shared/config/routes-config';
import { RouteConfig } from '../../../shared/interfaces/routes-config.interface';

import Countdown from 'react-countdown';
import { ReservationChannel } from '../../../shared/enums/reservation-channel.enum';
import { ReservationSource } from '../../../shared/enums/reservation-souce.enum';
import { hasAccess } from '../../../shared/services/helpers/auth-helper/auth-helper.service';
import { PERMISSIONS_LIST } from '../../../shared/config/permissions.config';
import { Pagination } from '../../../shared/components/core-ui/pagination/pagination.component';
import ReactDatePicker from 'react-datepicker';
import { UnitTypeGroupUiModel } from '../../../shared/ui-models/unit-type-group.ui-model';
import { NotFoundData } from '../../../ui/NotFoundData';
import { LoadingData } from '../../../ui/LoadingData';
import Modal from '../../../ui/Model';
import { ChevronRightIcon, Edit, FilterIcon } from '../../../ui/Icons';
import moment from 'moment';
import NumberFormat from 'react-number-format';
import { birdToast } from '../../../shared/components/core-ui/toast';
import Tooltip from '../../../ui/Tooltip';
import { ReservationsCreateContainer } from '../reservation-create/reservation-create.container';
import { getAllProperties } from '../../../PropertyModule/shared/services/data.service';
import { PropertyUiModel } from '../../../shared/ui-models/property.ui-model';
import {
  getReservationChannelImage,
  getReservationChannelLabel,
  getReservationSourceImage,
  getReservationSourceLabel
} from '../../../shared/services/helpers/reservation-source-channel.helper';
import {
  AppliedFilterChip,
  AppliedFilterKey,
  buildAppliedFilterChips,
  getSegmentLabel
} from '../../shared/services/reservation-applied-filters';
import { ReservationTypeOfStay } from '../../../shared/enums/reservation-type-of-stay.enum';
import {
  marketingChannelOptions,
  messagingChannelOptions
} from '../../../shared/interfaces/attribution.interface';
import { getAllCompanies } from '../../../CompanyModule/shared/services/data.service';
import { getAllBrokers } from '../../../shared/services/data/broker.data';
import { getSalesPersons } from '../../../SalesPersonsModule/data.service';

const getStatusStyles = (status: string) => {
  switch (status) {
    case ReservationStatus.CHECKED_IN:
    case ReservationStatus.CHECKED_IN_STARTED:
      return 'bg-primary-500 text-primary-50 border-primary-200';
    case ReservationStatus.PENDING_CHECK_IN:
    case ReservationStatus.CONFIRMATION_PENDING:
      return 'bg-yellow-50 text-yellow-500 border-yellow-400';
    case ReservationStatus.CANCELED:
      return 'bg-red-100 text-red-800 border-red-100';
    case ReservationStatus.CHECKED_OUT:
      return 'bg-gray-100 text-neutral-800 border-gray-200';
    case ReservationStatus.EXPIRED:
      return 'bg-scarlet text-white border-scarlet';
    case ReservationStatus.IN_HOUSE:
      return 'bg-primary-50 text-primary-600 border-primary-100';
    default:
      return 'bg-blue-50 text-blue-600 border-blue-100';
  }
};

const OTA_FOLLOW_UP_TAB = "OTA's follow Up";
const otaFollowUpReservationStatuses = Object.values(ReservationStatus).filter(
  (status) => status !== ReservationStatus.CANCELED
);

type Option = { value: string; label: string };

const segmentOptions: Option[] = Object.values(ReservationTypeOfStay).map((value) => ({
  value,
  label: getSegmentLabel(value)
}));

const yesNoOptions: Option[] = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' }
];

const toYesNo = (value: string): boolean | undefined =>
  value === 'yes' ? true : value === 'no' ? false : undefined;

const reservationTabOptions = [
  { value: 'All', label: 'All' },
  { value: 'Attention Required', label: 'Attention Required' },
  { value: OTA_FOLLOW_UP_TAB, label: OTA_FOLLOW_UP_TAB },
  { value: 'Follow up Required', label: 'Follow up Required' },
  { value: 'Currently Hosting', label: 'Currently Hosting' },
  { value: 'Upcoming', label: 'Upcoming' },
  { value: 'Checked Out', label: 'Checked Out' },
  { value: 'Cancelled', label: 'Cancelled' },
  { value: 'My assigned reservations', label: 'My assigned reservations' },
  { value: 'Today reservations', label: 'Today reservations' }
];

function Row(props: { reservation: ReservationUiModel }) {
  const { reservation } = props;

  const renderSourceImage = () => {
    const src = getReservationSourceImage(reservation.source);
    const label = getReservationSourceLabel(reservation.source);

    return <img className="size-16 object-contain" src={src} alt={label} />;
  };

  const renderChannelImage = () => {
    const src = getReservationChannelImage(reservation.channel);
    const label = getReservationChannelLabel(reservation.channel);

    return <img className="size-12 object-contain" src={src} alt={label} />;
  };

  return (
    <tr
      className={`
         border-b border-gray-100
        ${
          reservation.status === ReservationStatus.CHECKED_IN_STARTED ? 'bg-secondary-50/60' : ''
        } ${reservation.status === ReservationStatus.CANCELED ? 'bg-red-100/20' : ''}
      ${reservation.status === ReservationStatus.EXPIRED ? 'bg-red-100/20' : ''}

        ${reservation.status === ReservationStatus.CHECKED_OUT ? 'bg-gray-200/25' : ''}
        ${reservation.status === ReservationStatus.IN_HOUSE ? 'bg-primary-50/90' : ''}
        ${reservation.status === ReservationStatus.CHECKED_IN ? 'bg-primary-50/90' : ''}
        ${reservation.status === ReservationStatus.CONFIRMATION_PENDING ? 'bg-amber-50/60' : ''}
      `}
    >
      <td className="py-4 px-4 align-middle whitespace-nowrap">
        <div className="flex flex-col items-center gap-3">
          <Button
            type={ButtonType.transparent}
            aria-controls="property-menu"
            aria-haspopup="true"
            onClick={() => {
              window.open(
                PUBLIC_PATH +
                  (APP_ROUTES.RESERVATION_MODULE.CHILDREN as RouteConfig).EDIT.FULL_PATH.replace(
                    ':id',
                    reservation.id as string
                  ),
                '_blank'
              );
            }}
            classNameButton="text-neutral-400 hover:text-primary-500 transition-colors p-1 rounded-full hover:bg-gray-100"
            className="min-w-fit p-0"
          >
            <Edit size="16" />
          </Button>
          <div className="flex items-center gap-1.5 whitespace-nowrap">
            <span className="text-neutral-500 text-lg font-gilroy-medium">{reservation.id}</span>
            {reservation.relatedReservationId && (
              <Tooltip
                title={`Linked to reservation #${reservation.relatedReservationId}`}
                placement="top"
              >
                <button
                  type="button"
                  className="inline-flex items-center gap-0.5 text-sm font-gilroy-medium text-blue-600 hover:text-blue-800"
                  onClick={() => {
                    window.open(
                      PUBLIC_PATH +
                        (
                          APP_ROUTES.RESERVATION_MODULE.CHILDREN as RouteConfig
                        ).EDIT.FULL_PATH.replace(
                          ':id',
                          String(reservation.relatedReservationId) || ''
                        ),
                      '_blank'
                    );
                  }}
                  aria-label={`Open related reservation ${reservation.relatedReservationId}`}
                >
                  <span aria-hidden="true">↔</span>
                  {reservation.relatedReservationId}
                </button>
              </Tooltip>
            )}
          </div>
        </div>
      </td>

      <td className="align-middle p-1">
        <div className="inline-flex items-center gap-2 min-w-[100px] cursor-help">
          <Tooltip
            title={
              <span className="text-base font-gilroy-medium">
                Source: {getReservationSourceLabel(reservation.source)}
              </span>
            }
            placement="top"
          >
            {renderSourceImage()}
          </Tooltip>
          <ChevronRightIcon className="size-5" fontSize="small" />
          <Tooltip
            title={
              <span className="text-base font-gilroy-medium ">
                Channel: {getReservationChannelLabel(reservation.channel)}
              </span>
            }
            placement="top"
          >
            {renderChannelImage()}
          </Tooltip>
        </div>
      </td>

      <td className="p-4  align-middle">
        <div className="flex flex-col justify-between items-start gap-2">
          <span
            className={`
                inline-flex items-center p-1 rounded-lg font-gilroy-medium text-sm font-extrabold uppercase tracking-wide border
                ${getStatusStyles(reservation.status)}
            `}
          >
            {reservation.status ? reservation.status.replace('_', ' ') : 'Unknown'}
            {(reservation.status === ReservationStatus.CONFIRMATION_PENDING ||
              reservation.status === ReservationStatus.CHECKED_IN_STARTED) && (
              <Countdown
                date={
                  new Date(
                    new Date(Number(reservation.checkinExpiresAt)).getTime() + 60 * 60 * 24 * 1000
                  )
                }
                renderer={({ hours, minutes }: { hours: number; minutes: number }) => {
                  return (
                    <span className="text-yellow-500 min-w-fit flex font-gilroy-medium font-medium text-base lowercase">
                      {hours ? `${hours}h` : ''} {hours && minutes ? ' : ' : ''}{' '}
                      {minutes ? `${minutes}m` : ''}
                    </span>
                  );
                }}
              />
            )}
          </span>

          {(!reservation.guestIds || reservation.guestIds.length === 0) &&
            reservation.source !== ReservationSource.CHANNEL_MANAGER && (
              <Tooltip
                title={
                  <span className="text-base font-gilroy-medium">
                    Guest identification documents are missing
                  </span>
                }
                placement="top"
              >
                <span className="flex items-center gap-2 font-gilroy-medium text-base text-red-500  bg-gradient-to-r min-w-[130px]  p-1 rounded-lg border border-red-200 cursor-help from-red-100 to-red-50 ">
                  <span className="size-2 rounded-full bg-red-400 animate-pulse shadow-sm" />
                  Guest Data Incomplete
                </span>
              </Tooltip>
            )}

          {reservation.promoCodeUsed && (
            <span className="inline-flex items-center p-1 rounded-lg font-gilroy-medium text-sm uppercase tracking-wide border border-primary-200 bg-primary-50 text-primary-700">
              {reservation.promoCodeUsed}
            </span>
          )}
        </div>
      </td>

      <td className="p-4 align-middle text-center">
        <span className="text-lg  text-neutral-500">
          {reservation.primaryGuestName || 'Unknown'}
        </span>
      </td>

      <td className="py-4 px-4 align-middle text-xl text-neutral-600 whitespace-nowrap font-medium text-center">
        {moment(reservation.checkInDate).format('ddd M/D/YYYY')}
      </td>
      <td className="py-4 px-4 align-middle text-xl text-neutral-600 whitespace-nowrap font-medium text-center">
        {moment(reservation.checkOutDate).format('ddd M/D/YYYY')}
      </td>
      <td className="p-4 font-gilroy-medium align-middle text-center">
        <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-gray-100 text-neutral-500 text-xl font-gilroy-medium">
          {reservation.numberOfNights}
        </span>
      </td>
      {/* <td className="p-4 font-gilroy-medium align-middle text-xl font-bold text-neutral-900">
        {!reservation.totalPaymentAmount ? (
          ' - '
        ) : (
          <NumberFormat
            value={reservation.totalPaymentAmount}
            displayType={'text'}
            thousandSeparator={true}
            // prefix={reservation.currency ? CURRENCY[reservation.currency] + ' ' : 'EGP '}
          />
        )}
      </td> */}

      <td className="py-4 px-4 align-middle text-xl text-neutral-600 text-center">
        {reservation.area}
      </td>
      <td className="py-4 px-4 align-middle text-xl text-neutral-600 text-center">
        {reservation.propertyName}
      </td>

      <td className="py-4 px-4 align-middle text-center">
        <Tooltip
          title={<span className="text-base font-gilroy-medium">{reservation.unitName}</span>}
          placement="top"
        >
          <button
            onClick={() => {
              window.open(WEBSITE_HOME + 'unit/' + reservation.unitTypeId, '_blank');
            }}
          >
            <div className="max-w-[140px] truncate text-xl font-gilroy-medium text-neutral-500 px-2.5 py-1 rounded-lg border border-gray-200 cursor-help">
              {reservation.unitName.replace(/(^.*\(|\).*$)/g, '')}
            </div>
          </button>
        </Tooltip>
      </td>

      <td className="p-4 text-center ">
        <span className="font-gilroy-medium text-center align-middle text-xl text-neutral-500">
          {reservation.unitTypeGroupName}
        </span>
      </td>
      <td className="p-4 min-w-[90px] font-gilroy-medium align-middle text-xl text-center text-neutral-500 ">
        <Tooltip
          title={
            <span className="text-lg font-gilroy-medium">
              {moment(reservation.createdAt).format('DD-MM-YYYY hh:mm a')}
              {reservation.modifiedByUsername && (
                <span className="block">last modified by: {reservation.modifiedByUsername}</span>
              )}
            </span>
          }
          placement="left"
        >
          <span>{moment(reservation.createdAt).format('DD-MM-YYYY')}</span>
        </Tooltip>
      </td>
    </tr>
  );
}

export const ReservationsListContainer = ({ userId }: { userId: string | undefined }) => {
  const isMobileView = useWindowResizer();

  const tabConfigs: Record<string, { query?: any; selectedStatus?: any; searchQuery?: any }> = {
    All: { query: {}, selectedStatus: {} },
    'Attention Required': {
      query: {
        isValidated: false,
        statusQuery: [ReservationStatus.CHECKED_IN, ReservationStatus.PENDING_CHECK_IN]
      },
      selectedStatus: {
        isValidated: false,
        statusQuery: [ReservationStatus.PENDING_CHECK_IN, ReservationStatus.CHECKED_IN]
      }
    },
    [OTA_FOLLOW_UP_TAB]: {
      query: {
        source: ReservationSource.CHANNEL_MANAGER,
        statusQuery: otaFollowUpReservationStatuses
      },
      selectedStatus: {
        source: ReservationSource.CHANNEL_MANAGER,
        statusQuery: otaFollowUpReservationStatuses
      }
    },
    Upcoming: {
      query: { status: ReservationStatus.CHECKED_IN },
      selectedStatus: { status: ReservationStatus.CHECKED_IN }
    },
    'Currently Hosting': {
      query: { status: ReservationStatus.IN_HOUSE },
      selectedStatus: { status: ReservationStatus.IN_HOUSE }
    },
    'Follow up Required': {
      query: { statusQuery: [ReservationStatus.CONFIRMATION_PENDING, ReservationStatus.EXPIRED] },
      selectedStatus: {
        statusQuery: [ReservationStatus.CONFIRMATION_PENDING, ReservationStatus.EXPIRED]
      }
    },
    'Checked Out': {
      query: { status: ReservationStatus.CHECKED_OUT },
      selectedStatus: { status: ReservationStatus.CHECKED_OUT }
    },
    Cancelled: {
      query: { status: ReservationStatus.CANCELED },
      selectedStatus: { status: ReservationStatus.CANCELED }
    },
    'My assigned reservations': {
      query: { assignedReservations: { userId } },
      selectedStatus: {}
    },
    'Today reservations': {
      query: { range: 'today' },
      selectedStatus: {},
      searchQuery: { range: 'today' }
    }
  };

  const [guestName, setGuestName] = useState('');
  const [guestEmail, setGuestEmail] = useState('');
  const [guestPhone, setGuestPhone] = useState('');
  const [id, setId] = useState('');
  const [cmId, setCmId] = useState('');
  const [area, setArea] = useState('');
  const [channel, setChannel] = useState('');
  const [status, setStatus] = useState('');
  const [reservations, setReservations] = useState<ReservationUiModel[]>([]);
  const [unitType, setUnitType] = useState<{
    value: string | undefined;
    label: string | undefined;
  }>({
    value: '',
    label: ''
  });
  const [areaOptions, setAreaOptions] = useState<
    { value: string; label: string; areaId: string }[]
  >([]);
  const [allProjects, setAllProjects] = useState<PropertyUiModel[]>([]);
  const [unitTypeOptions, setUnitTypeOptions] = useState<{ value: string; label: string }[]>([]);
  const [showCreateReservation, setShowCreateReservation] = useState<boolean>(false);
  const [reservationType, setReservationType] = useState<string>();
  const [loadingData, setLoadingData] = useState<boolean>(false);
  const [listCount, setListCount] = useState<number>(0);
  const [offset, setOffset] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [selectedStatus, setSelectedStatus] = useState<any>(tabConfigs['All'].selectedStatus);
  const [searchQuery, setSearchQuery] = useState<any>({});
  const [startCreatedDate, setStartCreatedDate] = useState<Date>();
  const [endCreatedDate, setEndCreatedDate] = useState<Date>();
  const [CheckInDate, setCheckInDate] = useState<Date>();
  const [checkoutDate, setCheckoutDate] = useState<Date>();
  const [numberOfNights, setNumberOfNights] = useState<string>('');
  const [source, setSource] = useState('');
  const [city, setCity] = useState('');
  const [unitTypeGroup, setUnitTypeGroup] = useState('');
  const [paymentAmountRange, setPaymentAmountRange] = useState<{
    min: number | undefined;
    max: number | undefined;
  }>();
  const [citiesOptions, setCitiesOptions] = useState<
    {
      value: string;
      label: string;
    }[]
  >([]);
  const [unitTypeGroupsList, setUnitTypeGroupsList] = useState<
    {
      value: string;
      label: string;
    }[]
  >([]);
  const [typeOfStay, setTypeOfStay] = useState('');
  const [companyId, setCompanyId] = useState('');
  const [brokerId, setBrokerId] = useState('');
  const [marketingChannel, setMarketingChannel] = useState('');
  const [messagingChannel, setMessagingChannel] = useState('');
  const [salesPersonId, setSalesPersonId] = useState('');
  const [isComplimentary, setIsComplimentary] = useState('');
  const [isLinked, setIsLinked] = useState('');
  const [linkedReservationId, setLinkedReservationId] = useState('');
  const [companyOptions, setCompanyOptions] = useState<Option[]>([]);
  const [brokerOptions, setBrokerOptions] = useState<Option[]>([]);
  const [salesPersonOptions, setSalesPersonOptions] = useState<Option[]>([]);
  const [filtersModalOpen, setFiltersModalOpen] = useState<boolean>(false);
  const [selectedTab, setSelectedTab] = useState<string>('All');

  const reInitialize = () => {
    setOffset(1);
    setArea('');
    setGuestName('');
    setGuestEmail('');
    setGuestPhone('');
    setId('');
    setCmId('');
    setChannel('');
    setStatus('');
    setStartCreatedDate(undefined);
    setEndCreatedDate(undefined);
    setCheckInDate(undefined);
    setCheckoutDate(undefined);
    setSearchQuery({});
    setUnitType({ value: '', label: '' });
    setNumberOfNights('');
    setSource('');
    setCity('');
    setPaymentAmountRange({ min: undefined, max: undefined });
    setUnitTypeGroup('');
    setTypeOfStay('');
    setCompanyId('');
    setBrokerId('');
    setMarketingChannel('');
    setMessagingChannel('');
    setSalesPersonId('');
    setIsComplimentary('');
    setIsLinked('');
    setLinkedReservationId('');
  };

  const handleTabChange = (tabKey: string) => {
    reInitialize();
    const config = tabConfigs[tabKey] || { query: {}, selectedStatus: {} };
    setSelectedStatus(config.selectedStatus || {});
    setSelectedTab(tabKey);
    if (config.searchQuery) setSearchQuery(config.searchQuery);
    getReservations(config.query || {}, 1, limit);
  };

  const getReservations = (query: object, offset: number, limit: number) => {
    setLoadingData(true);
    getAllReservations(query, offset, limit).then(
      (response: ReservationListUiModel | ErrorInfo) => {
        setLoadingData(false);
        if (isErrorInfo(response)) {
          setReservations([]);
          setListCount(0);
          return;
        }

        setListCount(response?.count);
        setReservations(response?.reservationList);
      }
    );
  };

  function downloadCSV(file: any) {
    const link = document.createElement('a');

    const binaryData = [];
    binaryData.push(file);
    link.href = window.URL.createObjectURL(new Blob(binaryData, { type: 'application/csv' }));

    link.setAttribute('download', 'reservation_data.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const exportReservations = (query: object, offset: number, limit: number) => {
    const promise = getAllReservations(query, offset, limit).then((response) => {
      setLoadingData(false);
      if (!isErrorInfo(response)) {
        downloadCSV(response);
      }
    });

    birdToast.promise(promise, {
      errorFailedMessage: 'Failed to export reservations',
      loadingMessage: 'Exporting reservations',
      successMessage: 'Reservations exported successfully',
      errorPermissionMessage: 'You do not have permission to export reservations'
    });
  };

  const buildQuery = (): any => {
    const query: any = {};
    if (unitType) {
      query.unitTypeId = unitType.value !== '' ? unitType.value : undefined;
    }
    if (guestName) {
      query.primaryGuestName = guestName;
    }
    if (guestEmail.trim()) {
      query.primaryGuestEmail = guestEmail.trim();
    }
    if (guestPhone.trim()) {
      query.primaryGuestPhone = guestPhone.trim();
    }
    if (area) {
      query.areaId = area;
    }
    if (id) {
      query.id = id;
    }
    if (cmId.trim()) {
      query.cmId = cmId.trim();
    }
    if (status) {
      query.status = status;
    }
    if (source) {
      query.source = source;
    }
    if (channel) {
      query.channel = channel;
    }
    if (numberOfNights) {
      query.numberOfNights = Number(numberOfNights);
    }
    if (city) {
      query.cityId = city;
    }
    if (startCreatedDate && endCreatedDate) {
      query.createdAtFrom = startCreatedDate.getTime();
      query.createdAtTo = endCreatedDate.getTime();
    }
    if (checkoutDate && CheckInDate) {
      query.checkInDate = CheckInDate.getTime();
      query.checkOutDate = checkoutDate.getTime();
    }
    if (paymentAmountRange?.min || paymentAmountRange?.max) {
      query.paymentAmountRange = {
        min: paymentAmountRange?.min || undefined,
        max: paymentAmountRange?.max || undefined
      };
    }
    if (unitTypeGroup) {
      query.unitTypeGroupId = unitTypeGroup;
    }
    if (typeOfStay) {
      query.typeOfStay = typeOfStay;
    }
    if (companyId) {
      query.companyId = Number(companyId);
    }
    if (brokerId) {
      query.brokerId = Number(brokerId);
    }
    if (marketingChannel) {
      query.marketingChannel = marketingChannel;
    }
    if (messagingChannel) {
      query.messagingChannel = messagingChannel;
    }
    if (salesPersonId) {
      query.salesPersonId = salesPersonId;
    }
    if (toYesNo(isComplimentary) !== undefined) {
      query.isComplimentary = toYesNo(isComplimentary);
    }
    const linkedId = linkedReservationId.replace(/^#/, '').trim();
    if (/^\d+$/.test(linkedId)) {
      query.linkedReservationId = Number(linkedId);
    } else if (toYesNo(isLinked) !== undefined) {
      query.isLinked = toYesNo(isLinked);
    }

    return query;
  };

  const handleSearchClick = () => {
    const query = buildQuery();

    setSearchQuery(query);
    setOffset(1);
    setFiltersModalOpen(false);
    getReservations({ ...selectedStatus, ...query }, 1, limit);
  };

  const handleExportClick = () => {
    const query = buildQuery();

    // isExport stays out of searchQuery, or paging afterwards would request a CSV.
    setSearchQuery(query);
    setOffset(1);
    setFiltersModalOpen(false);
    exportReservations({ ...selectedStatus, ...query, isExport: true }, 1, limit);
  };

  const handleClearClick = () => {
    reInitialize();
    setOffset(1);
    setFiltersModalOpen(false);
    getReservations(selectedStatus, 1, limit);
  };

  const filterResetters: Record<AppliedFilterKey, () => void> = {
    id: () => setId(''),
    cmId: () => setCmId(''),
    guestName: () => setGuestName(''),
    guestEmail: () => setGuestEmail(''),
    guestPhone: () => setGuestPhone(''),
    city: () => setCity(''),
    area: () => setArea(''),
    unitTypeGroup: () => setUnitTypeGroup(''),
    channel: () => setChannel(''),
    source: () => setSource(''),
    status: () => setStatus(''),
    unitType: () => setUnitType({ value: '', label: '' }),
    createdAt: () => {
      setStartCreatedDate(undefined);
      setEndCreatedDate(undefined);
    },
    stay: () => {
      setCheckInDate(undefined);
      setCheckoutDate(undefined);
    },
    numberOfNights: () => setNumberOfNights(''),
    paymentAmount: () => setPaymentAmountRange({ min: undefined, max: undefined }),
    segment: () => setTypeOfStay(''),
    company: () => setCompanyId(''),
    broker: () => setBrokerId(''),
    marketingChannel: () => setMarketingChannel(''),
    messagingChannel: () => setMessagingChannel(''),
    salesPerson: () => setSalesPersonId(''),
    complimentary: () => setIsComplimentary(''),
    linked: () => {
      setIsLinked('');
      setLinkedReservationId('');
    }
  };

  const handleRemoveFilter = (chip: AppliedFilterChip) => {
    filterResetters[chip.key]();
    const query = { ...searchQuery };
    chip.queryKeys.forEach((key) => delete query[key]);
    setSearchQuery(query);
    setOffset(1);
    getReservations({ ...selectedStatus, ...query }, 1, limit);
  };

  const appliedFilters = buildAppliedFilterChips(searchQuery, {
    cities: citiesOptions,
    areas: areaOptions,
    unitTypeGroups: unitTypeGroupsList,
    unitTypes: unitTypeOptions,
    companies: companyOptions,
    brokers: brokerOptions,
    salesPersons: salesPersonOptions
  });

  useEffect(() => {
    reInitialize();

    getReservations(tabConfigs['All'].query, offset, limit);

    getAllAreas(getModuleName()).then((response: AreaUiModel[] | ErrorInfo) => {
      if (!isErrorInfo(response)) {
        setAreaOptions(
          response.map((area) => ({
            value: area.name || '',
            label: area.name,
            areaId: area.id || ''
          }))
        );
      }
    });

    getAllCity(getModuleName()).then((response: any) => {
      if (!isErrorInfo(response)) {
        setCitiesOptions(response?.map((c: any) => ({ value: c.id || '', label: c.name })));
      }
    });

    getAllUnitTypeGroups(getModuleName()).then((response: UnitTypeGroupUiModel[] | ErrorInfo) => {
      if (!isErrorInfo(response)) {
        setUnitTypeGroupsList(
          response?.map((group) => ({ value: group.id || '', label: group.name }))
        );
      }
    });

    getAllCompanies().then((response) => {
      if (!isErrorInfo(response)) {
        setCompanyOptions(
          response.map((company) => ({
            value: String(company.id || ''),
            label: company.name || ''
          }))
        );
      }
    });

    getAllBrokers().then((response) => {
      if (!isErrorInfo(response)) {
        setBrokerOptions(
          response.map((broker) => ({ value: String(broker.id || ''), label: broker.name || '' }))
        );
      }
    });

    getSalesPersons().then((response) => {
      if (!isErrorInfo(response)) {
        setSalesPersonOptions(
          response.map((salesPerson) => ({
            value: salesPerson.id || '',
            label:
              salesPerson.name || salesPerson.email || salesPerson.phone || 'Unnamed sales person'
          }))
        );
      }
    });

    getAllProperties().then((res) => {
      if (!isErrorInfo(res)) {
        setAllProjects(res as PropertyUiModel[]);
      }
    });

    getAllUnitTypes(getModuleName(), 0, -1, {}).then(
      (response: UnitTypeUiModelResponse | ErrorInfo) => {
        if (!isErrorInfo(response)) {
          setUnitTypeOptions(
            response?.unitList?.map((unitType) => ({
              value: unitType.id || '',
              label: unitType.name || ''
            }))
          );
        }
      }
    );
  }, []);

  const displayedReservations =
    selectedTab === OTA_FOLLOW_UP_TAB
      ? reservations.filter(
          (reservation) => !reservation?.guestIds || reservation?.guestIds?.length === 0
        )
      : reservations;

  return (
    <>
      <div className="item-start pt-4 pb-[3rem] px-[2rem] bg-creams-50 min-h-screen relative">
        <span className=" block text-4xl font-recoleta mb-6 font-semibold">Reservations List</span>
        <div className="flex items-center justify-between mb-2 px-4 pb-4 border-b-2 border-neutral-50 border-dotted">
          <Select
            value={{ value: selectedTab, label: selectedTab }}
            options={reservationTabOptions}
            onChange={(value: ValueType<{ value: string; label: string }, false>) =>
              handleTabChange(value ? value.value : '')
            }
            classNamePrefix="react-select"
            className="w-64 !h-[39px]"
          />
          <div className={'flex justify-end items-center gap-4'}>
            {hasAccess([
              PERMISSIONS_LIST.reservationsFullAccess,
              PERMISSIONS_LIST.reservationsModifyAccess
            ]) && (
              <>
                <Button
                  onClick={() => {
                    setReservationType('NORMAL_RESERVATION');
                    setShowCreateReservation(true);
                    birdToast.warning('Please Select Area first');
                  }}
                  tracking={{ event: 'record_edit_started', entity: 'reservation' }}
                  size={ButtonSize.small}
                >
                  Create Reservations
                </Button>

                <Button
                  onClick={() => {
                    setReservationType('BLOCK_DATES');
                    setShowCreateReservation(true);
                  }}
                  tracking={{ event: 'record_edit_started', entity: 'block_date' }}
                  type={ButtonType.primaryInverted}
                  size={ButtonSize.small}
                >
                  Block Dates
                </Button>
              </>
            )}
            <div className="relative">
              <Button
                onClick={() => setFiltersModalOpen((prev) => !prev)}
                type={ButtonType.primaryInverted}
                size={ButtonSize.small}
                classNameButton="p-[5px]"
              >
                <FilterIcon />
              </Button>
              {appliedFilters.length > 0 && (
                <span
                  className="absolute -top-2 -right-2 min-w-[20px] h-5 px-1 flex items-center justify-center rounded-full bg-secondary-500 text-white text-sm font-gilroy-bold pointer-events-none"
                  aria-label={`${appliedFilters.length} filters applied`}
                >
                  {appliedFilters.length}
                </span>
              )}
            </div>
          </div>
        </div>

        {appliedFilters.length > 0 && (
          <div className="flex flex-wrap items-center gap-2 mb-4 px-4">
            <span className="text-lg font-gilroy-medium text-neutral-500 mr-1">Filtered by:</span>
            {appliedFilters.map((chip) => (
              <span
                key={chip.key}
                className="inline-flex items-center gap-1 rounded-full border border-primary-200 bg-primary-50 pl-3 pr-1 py-1 text-base font-gilroy-medium text-primary-600"
              >
                <button
                  type="button"
                  onClick={() => setFiltersModalOpen(true)}
                  className="max-w-[260px] truncate"
                  title={`${chip.label}: ${chip.value}`}
                >
                  <span className="text-neutral-500">{chip.label}:</span> {chip.value}
                </button>
                <button
                  type="button"
                  onClick={() => handleRemoveFilter(chip)}
                  className="flex items-center justify-center size-5 rounded-full text-lg leading-none text-primary-600 hover:bg-primary-100"
                  aria-label={`Remove ${chip.label} filter`}
                >
                  ×
                </button>
              </span>
            ))}
            <button
              type="button"
              onClick={handleClearClick}
              className="ml-1 text-base font-gilroy-medium text-neutral-500 underline hover:text-neutral-700"
            >
              Clear all
            </button>
          </div>
        )}

        {loadingData ? (
          <LoadingData />
        ) : (
          <>
            <div className="w-full overflow-x-auto mb-16">
              <table className="w-full" aria-label="table">
                <thead>
                  <tr className="[&>th]:text-xl [&>th]:py-2 [&>th]:font-gilroy-medium text-neutral-500 border-b-[1px] border-neutral-50 [&>th]:text-center ">
                    <th>Id</th>
                    <th>Channel</th>
                    <th>Tags</th>
                    <th>Name</th>
                    <th>Check In</th>
                    <th>Check Out</th>
                    <th>Nights</th>
                    {/* <th>Payment</th> */}
                    <th>Area</th>
                    <th>Property</th>
                    <th>Unit</th>
                    <th>Unit Type</th>
                    <th>Created At</th>
                  </tr>
                </thead>
                <tbody>
                  {displayedReservations?.map((reservation) => (
                    <Row key={reservation.id} reservation={reservation} />
                  ))}
                </tbody>
              </table>
            </div>
            {displayedReservations?.length === 0 && <NotFoundData />}
          </>
        )}
        {listCount > 0 && (
          <div className="fixed bottom-2 inset-x-0 mx-auto w-[90%] lg:w-[60%] flex justify-center items-center">
            <Pagination
              itemCounts={listCount}
              itemsPerPage={limit}
              offset={offset}
              handlePageChange={(newPage) => {
                setOffset(newPage);
                getReservations({ ...selectedStatus, ...searchQuery }, newPage, limit);
              }}
              handleItemsPerPage={(itemsPerPage) => {
                setLimit(itemsPerPage);
                getReservations({ ...selectedStatus, ...searchQuery }, offset, itemsPerPage);
              }}
            />
          </div>
        )}
      </div>

      {showCreateReservation && (
        <ReservationsCreateContainer
          reservationType={reservationType || ''}
          unitTypeGroupsList={unitTypeGroupsList?.map((g) => ({
            id: g.value,
            name: g.label
          }))}
          allProjects={allProjects?.map((p) => ({
            label: p.name || '',
            value: p.id || '',
            areaId: p.areaId || ''
          }))}
          allAreas={areaOptions}
          openModal={showCreateReservation}
          onClose={() => setShowCreateReservation(false)}
          eventHandlers={{
            closeHandler: () => setShowCreateReservation(false)
          }}
        />
      )}

      <Modal
        isOpen={filtersModalOpen}
        onClose={() => setFiltersModalOpen(false)}
        containerClassName="lg:h-fit lg:max-h-[80vh] lg:w-[850px]"
        headerContent={
          <div className="text-center font-gilroy-bold text-2xl leading-[100%] text-neutral-500">
            Filters
          </div>
        }
        headerAction={
          <Button
            onClick={handleClearClick}
            classNameButton="text-neutral-500 text-2xl"
            tracking={{ event: 'search_cleared', scope: 'unit-types' }}
            type={ButtonType.transparent}
          >
            Clear All
          </Button>
        }
        footerContent={
          <div className="flex justify-end gap-4">
            <Button
              onClick={handleSearchClick}
              tracking={{ event: 'record_edit_cancelled', entity: 'unit_type', method: 'close' }}
              size={isMobileView ? ButtonSize.full : ButtonSize.medium}
            >
              Search
            </Button>

            <Button
              onClick={handleExportClick}
              className={'px-4 py-2 rounded text-white bg-green-600 hover:bg-green-700'}
              size={isMobileView ? ButtonSize.full : ButtonSize.medium}
              type={ButtonType.primaryInverted}
            >
              Export
            </Button>
          </div>
        }
      >
        <div className="relative flex flex-col flex-wrap mt-4 mb-20 px-4 py-4 md:flex-row md:py-6 md:pl-8 md:pr-2">
          <div className="w-full sm:w-1/2 md:w-1/3 px-2 mb-4">
            <div className="text-xl font-medium font-gilroy-medium text-neutral-500 mb-1">
              Reservation number
            </div>
            <InputText
              data={{ value: id }}
              config={{ maxRows: 1, autoFocus: false }}
              eventHandlers={{ onChangeHandler: (value: string) => setId(value) }}
            />
          </div>
          <div className="w-full sm:w-1/2 md:w-1/3 px-2 mb-4">
            <div className="text-xl font-medium font-gilroy-medium text-neutral-500 mb-1">
              Rentals United ID
            </div>
            <InputText
              data={{ value: cmId }}
              config={{ maxRows: 1, autoFocus: false }}
              eventHandlers={{ onChangeHandler: (value: string) => setCmId(value) }}
            />
          </div>
          <div className="w-full sm:w-1/2 md:w-1/3 px-2 mb-4">
            <div className="text-xl font-medium font-gilroy-medium text-neutral-500 mb-1">
              Guest Name
            </div>
            <InputText
              data={{ value: guestName }}
              config={{ maxRows: 1, autoFocus: false }}
              eventHandlers={{ onChangeHandler: (value: string) => setGuestName(value) }}
            />
          </div>
          <div className="w-full sm:w-1/2 md:w-1/3 px-2 mb-4">
            <div className="text-xl font-medium font-gilroy-medium text-neutral-500 mb-1">
              Primary Email
            </div>
            <InputText
              data={{ value: guestEmail }}
              config={{ maxRows: 1, autoFocus: false }}
              eventHandlers={{ onChangeHandler: (value: string) => setGuestEmail(value) }}
            />
          </div>
          <div className="w-full sm:w-1/2 md:w-1/3 px-2 mb-4">
            <div className="text-xl font-medium font-gilroy-medium text-neutral-500 mb-1">
              Primary Phone
            </div>
            <InputText
              data={{ value: guestPhone }}
              config={{ maxRows: 1, autoFocus: false }}
              eventHandlers={{ onChangeHandler: (value: string) => setGuestPhone(value) }}
            />
          </div>
          <div className="w-full sm:w-1/2 md:w-1/3 px-2 mb-4">
            <div className="text-xl font-medium font-gilroy-medium text-neutral-500 mb-1">City</div>
            <Select
              value={{
                value: city,
                label: citiesOptions?.find((c) => c.value === city)?.label || city
              }}
              options={citiesOptions}
              className="w-full"
              classNamePrefix="react-select"
              onChange={(value: ValueType<{ value: string; label: string }, false>) =>
                setCity(value ? value.value : '')
              }
            />
          </div>
          <div className="w-full sm:w-1/2 md:w-1/3 px-2 mb-4">
            <div className="text-xl font-medium font-gilroy-medium text-neutral-500 mb-1">Area</div>
            <Select
              value={areaOptions.find((option) => option.areaId === area) || null}
              options={areaOptions}
              className="w-full"
              classNamePrefix="react-select"
              onChange={(
                value: ValueType<{ value: string; label: string; areaId: string }, false>
              ) => setArea(value ? value.areaId : '')}
            />
          </div>
          <div className="w-full sm:w-1/2 md:w-1/3 px-2 mb-4">
            <div className="text-xl font-medium font-gilroy-medium text-neutral-500 mb-1">
              UnitType Group
            </div>
            <Select
              value={{
                value: unitTypeGroup,
                label:
                  unitTypeGroupsList?.find((c) => c.value === unitTypeGroup)?.label || unitTypeGroup
              }}
              options={unitTypeGroupsList}
              className="w-full"
              classNamePrefix="react-select"
              onChange={(value: ValueType<{ value: string; label: string }, false>) =>
                setUnitTypeGroup(value ? value.value : '')
              }
            />
          </div>
          <div className="w-full sm:w-1/2 md:w-1/3 px-2 mb-4">
            <div className="text-xl font-medium font-gilroy-medium text-neutral-500 mb-1">
              Channel
            </div>
            <Select
              value={{ value: channel, label: channel }}
              options={Object.values(ReservationChannel)?.map((channel) => ({
                value: channel,
                label: channel.charAt(0).toUpperCase() + channel.slice(1)
              }))}
              className="w-full"
              classNamePrefix="react-select"
              onChange={(value: ValueType<{ value: string; label: string }, false>) =>
                setChannel(value ? value.value : '')
              }
            />
          </div>
          <div className="w-full sm:w-1/2 md:w-1/3 px-2 mb-4">
            <div className="text-xl font-medium font-gilroy-medium text-neutral-500 mb-1">
              Source
            </div>
            <Select
              value={{ value: source, label: source }}
              options={Object.values(ReservationSource)?.map((s) => ({
                value: s,
                label: s.charAt(0).toUpperCase() + s.replaceAll('-', ' ').slice(1)
              }))}
              className="w-full"
              classNamePrefix="react-select"
              onChange={(value: ValueType<{ value: string; label: string }, false>) =>
                setSource(value ? value.value : '')
              }
            />
          </div>
          <div className="w-full sm:w-1/2 md:w-1/3 px-2 mb-4">
            <div className="text-xl font-medium font-gilroy-medium text-neutral-500 mb-1">
              Reservation Status
            </div>
            <Select
              value={{ value: status, label: status?.replaceAll('_', ' ') }}
              options={Object.values(ReservationStatus)?.map((status) => ({
                value: status,
                label: status.charAt(0).toUpperCase() + status?.replaceAll('_', ' ')?.slice(1)
              }))}
              className="w-full"
              classNamePrefix="react-select"
              onChange={(value: ValueType<{ value: string; label: string }, false>) =>
                setStatus(value ? value.value : '')
              }
            />
          </div>
          <div className="w-full sm:w-1/2 md:w-1/3 px-2 mb-4">
            <div className="text-xl font-medium font-gilroy-medium text-neutral-500 mb-1">
              Unit Type
            </div>
            <Select
              value={{ value: unitType?.value, label: unitType?.label }}
              className="w-full"
              classNamePrefix="react-select"
              options={unitTypeOptions}
              onChange={(value: any) =>
                setUnitType({ value: value?.value || '', label: value?.label || '' })
              }
            />
          </div>
          <div className="w-full sm:w-1/2 md:w-1/3 px-2 mb-4">
            <div className="text-xl font-medium font-gilroy-medium text-neutral-500 mb-1">
              created at
            </div>
            <div className="flex gap-2">
              <ReactDatePicker
                selected={startCreatedDate}
                onChange={(date: Date) => {
                  setStartCreatedDate(date);
                  setEndCreatedDate(undefined);
                }}
                selectsStart
                startDate={startCreatedDate}
                endDate={endCreatedDate}
                placeholderText="Start Date"
              />
              <ReactDatePicker
                selected={endCreatedDate}
                onChange={(date: Date) => {
                  setEndCreatedDate(date);
                }}
                selectsEnd
                startDate={startCreatedDate}
                endDate={endCreatedDate}
                minDate={startCreatedDate}
                placeholderText="End Date"
              />
            </div>
          </div>
          <div className="w-full sm:w-1/2 md:w-1/3 px-2 mb-4">
            <div className="text-xl font-medium font-gilroy-medium text-neutral-500 mb-1">
              check in - checkout
            </div>
            <div className="flex gap-2">
              <ReactDatePicker
                selected={CheckInDate}
                onChange={(date: Date) => {
                  setCheckInDate(date);
                  setCheckoutDate(undefined);
                }}
                selectsStart
                startDate={CheckInDate}
                endDate={checkoutDate}
                placeholderText="check in Date"
              />
              <ReactDatePicker
                selected={checkoutDate}
                onChange={(date: Date) => {
                  setCheckoutDate(date);
                }}
                selectsEnd
                startDate={CheckInDate}
                endDate={checkoutDate}
                minDate={CheckInDate}
                placeholderText="checkout Date"
              />
            </div>
          </div>
          <div className="w-full sm:w-1/2 md:w-1/3 px-2 mb-4">
            <div className="text-xl font-medium font-gilroy-medium text-neutral-500 mb-1">
              Number of nights
            </div>
            <InputText
              data={{ value: numberOfNights }}
              config={{ maxRows: 1, autoFocus: false }}
              eventHandlers={{ onChangeHandler: (value: string) => setNumberOfNights(value) }}
            />
          </div>

          <div className="w-full sm:w-1/2 md:w-1/3 px-2 mb-4">
            <div className="text-xl font-medium font-gilroy-medium text-neutral-500 mb-1">
              Payment Amount
            </div>
            <div className="flex gap-2">
              <InputText
                data={{ value: paymentAmountRange?.min || '', placeholder: 'Min' }}
                config={{ maxRows: 1, autoFocus: false, type: InputTextType.number }}
                eventHandlers={{
                  onChangeHandler: (value: string) =>
                    setPaymentAmountRange((prev) => ({
                      ...prev,
                      min: Number(value),
                      max: prev?.max
                    }))
                }}
              />
              <InputText
                data={{ value: paymentAmountRange?.max || '', placeholder: 'Max' }}
                config={{ maxRows: 1, autoFocus: false, type: InputTextType.number }}
                eventHandlers={{
                  onChangeHandler: (value: string) =>
                    setPaymentAmountRange((prev) => ({
                      ...prev,
                      min: prev?.min,
                      max: Number(value)
                    }))
                }}
              />
            </div>
          </div>
          <div className="w-full sm:w-1/2 md:w-1/3 px-2 mb-4">
            <div className="text-xl font-medium font-gilroy-medium text-neutral-500 mb-1">
              Segment
            </div>
            <Select
              value={segmentOptions.find((option) => option.value === typeOfStay) || null}
              options={segmentOptions}
              isClearable
              className="w-full"
              classNamePrefix="react-select"
              onChange={(value: ValueType<Option, false>) =>
                setTypeOfStay(value ? value.value : '')
              }
            />
          </div>
          <div className="w-full sm:w-1/2 md:w-1/3 px-2 mb-4">
            <div className="text-xl font-medium font-gilroy-medium text-neutral-500 mb-1">
              Company Name
            </div>
            <Select
              value={companyOptions.find((option) => option.value === companyId) || null}
              options={companyOptions}
              isClearable
              className="w-full"
              classNamePrefix="react-select"
              onChange={(value: ValueType<Option, false>) => setCompanyId(value ? value.value : '')}
            />
          </div>
          <div className="w-full sm:w-1/2 md:w-1/3 px-2 mb-4">
            <div className="text-xl font-medium font-gilroy-medium text-neutral-500 mb-1">
              Broker
            </div>
            <Select
              value={brokerOptions.find((option) => option.value === brokerId) || null}
              options={brokerOptions}
              isClearable
              className="w-full"
              classNamePrefix="react-select"
              onChange={(value: ValueType<Option, false>) => setBrokerId(value ? value.value : '')}
            />
          </div>
          <div className="w-full sm:w-1/2 md:w-1/3 px-2 mb-4">
            <div className="text-xl font-medium font-gilroy-medium text-neutral-500 mb-1">
              Marketing Channel
            </div>
            <Select
              value={
                marketingChannelOptions.find((option) => option.value === marketingChannel) || null
              }
              options={marketingChannelOptions}
              isClearable
              className="w-full"
              classNamePrefix="react-select"
              onChange={(value: ValueType<Option, false>) =>
                setMarketingChannel(value ? value.value : '')
              }
            />
          </div>
          <div className="w-full sm:w-1/2 md:w-1/3 px-2 mb-4">
            <div className="text-xl font-medium font-gilroy-medium text-neutral-500 mb-1">
              Messaging Channel
            </div>
            <Select
              value={
                messagingChannelOptions.find((option) => option.value === messagingChannel) || null
              }
              options={messagingChannelOptions}
              isClearable
              className="w-full"
              classNamePrefix="react-select"
              onChange={(value: ValueType<Option, false>) =>
                setMessagingChannel(value ? value.value : '')
              }
            />
          </div>
          <div className="w-full sm:w-1/2 md:w-1/3 px-2 mb-4">
            <div className="text-xl font-medium font-gilroy-medium text-neutral-500 mb-1">
              Sales Person
            </div>
            <Select
              value={salesPersonOptions.find((option) => option.value === salesPersonId) || null}
              options={salesPersonOptions}
              isClearable
              className="w-full"
              classNamePrefix="react-select"
              onChange={(value: ValueType<Option, false>) =>
                setSalesPersonId(value ? value.value : '')
              }
            />
          </div>
          <div className="w-full sm:w-1/2 md:w-1/3 px-2 mb-4">
            <div className="text-xl font-medium font-gilroy-medium text-neutral-500 mb-1">
              Complimentary
            </div>
            <Select
              value={yesNoOptions.find((option) => option.value === isComplimentary) || null}
              options={yesNoOptions}
              isClearable
              className="w-full"
              classNamePrefix="react-select"
              onChange={(value: ValueType<Option, false>) =>
                setIsComplimentary(value ? value.value : '')
              }
            />
          </div>
          <div className="w-full sm:w-1/2 md:w-1/3 px-2 mb-4">
            <div className="text-xl font-medium font-gilroy-medium text-neutral-500 mb-1">
              Linked reservation
            </div>
            <div className="flex gap-2">
              <Select
                value={yesNoOptions.find((option) => option.value === isLinked) || null}
                options={yesNoOptions}
                isClearable
                isDisabled={!!linkedReservationId.trim()}
                className="w-1/2"
                classNamePrefix="react-select"
                onChange={(value: ValueType<Option, false>) =>
                  setIsLinked(value ? value.value : '')
                }
              />
              <InputText
                data={{ value: linkedReservationId, placeholder: 'Linked ID' }}
                config={{ maxRows: 1, autoFocus: false }}
                eventHandlers={{
                  onChangeHandler: (value: string) => setLinkedReservationId(value)
                }}
              />
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default connect((state: RootState) => ({ userId: state.auth.userId }))(
  ReservationsListContainer
);
